import React from 'react';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { displayAlert } from '../../../../slices/feedbackSlice';
import { deleteCustomer } from '../../../../slices/customersSlice';

const useStyles = makeStyles()((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  actions: {
    justifyContent: 'space-between',
  },
}));

export default function DeleteCustomerModal({ display, handleClose, customer = {} }) {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation('customers');

  const handleDelete = () => {
    dispatch(deleteCustomer(customer))
      .unwrap()
      .then(() => {
        dispatch(displayAlert(t('delete_customer.success'), 'success'));
        handleClose();
      })
      // Le thunk a déjà affiché le message rendu par l'API : en ajouter un
      // second empilait deux alertes pour un seul échec. Le `catch` reste
      // pour absorber le rejet — sans lui, `unwrap()` produit une promesse
      // rejetée sans traitement — et la fenêtre reste ouverte, ce qui est le
      // bon comportement : le retrait n'a pas eu lieu.
      .catch(() => {});
  };

  const name = [customer.first_name, customer.last_name].filter(Boolean).join(' ');

  return (
    <Dialog
      open={display}
      onClose={handleClose}
      fullWidth
      aria-labelledby="remove-customer-title"
    >
      <DialogTitle id="remove-customer-title">
        <Typography type="h3" variant="h3">
          {t('delete_customer.title')}
        </Typography>
        <IconButton
          aria-label={t('delete_customer.close_button')}
          className={classes.closeButton}
          onClick={handleClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography type="p" variant="body1">
          {t('delete_customer.confirm', { name })}
        </Typography>
        {/* Le membre sort des listes, ses prêts restent : c'est ce que fait
            l'API, et c'est ce que la personne doit lire avant de cliquer. */}
        <Typography type="p" variant="body2">
          {t('delete_customer.lendings_kept')}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button variant="contained" component="label" color="secondary" onClick={handleClose}>
          {t('delete_customer.cancel_button')}
        </Button>
        <Button variant="contained" component="label" color="primary" onClick={handleDelete}>
          {t('delete_customer.delete_button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
